import { useEffect, useRef, useState } from "react";
import { listaColoresChart } from "../Components/shared/colores";
import * as XLSX from 'xlsx';
import { getDataGrafico } from "../services/service";
import Select from 'react-select';
import html2canvas from "html2canvas";
import { InterfaceGraph } from "../interfaces/InterfaceGraph";
import LineChart from "./defaultViewLineChart";
import LineChartMini from "./defaultViewLineChartMini";

const customStyles = {
    option: (provided: any, state: any) => ({
        ...provided,
        padding: 4,
        fontSize: 11,
    }),
    multiValue: (base: any, state: any) => {
        return { ...base, fontSize: 14 };
    },
    singleValue: (provided: any, state: any) => {
        const opacity = state.isDisabled ? 0.5 : 1;
        const transition = 'opacity 300ms';
        return { ...provided, opacity, transition };
    }
};

const defaultData = {
    label: '',
    data: [],
    borderColor: '',
    fill: false,
    tension: 0.4,
};


 const MainCP: React.FC<InterfaceGraph> = (props) => {
  console.log('2. PROOOOOOPS',props)
    const divRef = useRef(null);

    const { idTipoGraficoProps,nameTitleProps,tituloProps='',subtitleProps='',selectValueProsp=[],formatDataStringData='%',disableFilterProps=false,numDecimalProps=0,pieTextProps='',showPieTextInGraph=true,showLineTop=true,showSeries=true,isRevertGraphY=false,bottonLegend=false,sharedLegend=true,showCategory=true,mostrarlegend=true,isThousandFormat=false, enableMiniBox=props.enableMiniBox, isYAxisActive=props.isYAxisActive} = props;
 

 
    return (
      <>
      {
        enableMiniBox
        ? <LineChartMini {...props} />
        :<LineChart {...props}/>
      }
      
      </>
    )
  }
  
 

  export default MainCP;
  